module.exports = __webpack_public_path__ + "img/video-12.8882e7f5.png";